// extracted by mini-css-extract-plugin
export default {"achievement":"Achievement_achievement__0K0Er"};